import React from 'react'
import { Content } from 'antd/lib/layout/layout'
import { Card, Input, Typography } from 'antd'
import { Button, Table } from 'components'
import { IcPlus, IcSearch } from 'assets/icons'

const ServisUmumComponent = ({ columns, data, onAdd, isLoading, tableState, setTableState }) => {
  const handlePerRowsChange = (newPerPage) => {
    setTableState((prev) => ({
      ...prev,
      limit: newPerPage,
      offset: 0
    }))
  }

  const onChangePage = (page) => {
    setTableState((prev) => ({
      ...prev,
      offset: page
    }))
  }

  return (
    <Content className="h-screen">
      <Card className="rounded-lg">
        <div className="flex justify-between mb-5">
          <Typography.Text className="font-semibold text-2xl">Servis Umum</Typography.Text>
          <Button
            className="flex flex-row items-center justify-around rounded-md space-x-1 px-2 py text-md text-white bg-primary-500 border-primary-500"
            onClick={onAdd}>
            <IcPlus className="text-white" size={19} />
            <span>Tambah Servis Umum</span>
          </Button>
        </div>
        <div className="mb-5">
          <Input
            className="w-1/4 rounded-md py-1.5"
            placeholder="Pencarian"
            prefix={<IcSearch className="text-gray-400" />}
            value={tableState?.keywords}
            onChange={(e) => setTableState((prev) => ({ ...prev, keywords: e?.target?.value }))}
          />
        </div>
        <Table
          columns={columns}
          data={data}
          pending={isLoading}
          totalRows={tableState?.totalRows}
          handlePerRowsChange={handlePerRowsChange}
          pageSize={tableState?.limit}
          page={tableState?.offset}
          onChangePrevPage={() => {
            if (tableState?.offset > 0) {
              onChangePage(tableState?.offset - tableState?.limit)
            }
          }}
          onChangeNextPage={() => {
            if (tableState?.totalRows > tableState?.limit + tableState?.offset) {
              onChangePage(tableState?.offset + tableState?.limit)
            }
          }}
        />
      </Card>
    </Content>
  )
}

export default ServisUmumComponent
